<template>
  <div>
    <headerSection :menuData="menuData" />

    <div class="flex">
      <Sidebar :menuData="menuData" v-if="!ai_sid && !ai_uuid && authorized" class="hidden xl:block" />
      <!-- <Sidebar :menuData="menuData" v-if="authorized" /> -->

      <div class="contain-main gept_main_bg3 flex-1 p-2 xl:p-6">
        <router-view class="view_contain"></router-view>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import headerSection from '@/components/GEPT/headerSection'
  import Sidebar from '@/components/GEPT/sidebar'
  export default {
    name: 'Layout',
    metaInfo: {
      title: 'GEPT'
    },
    components: {
      headerSection,
      Sidebar
    },

    data () {
      return {
        menuData: null
      }
    },

    computed: {
      ...mapGetters([
        'authorized',
        'remainPoints',
        'ai_sid',
        'ai_uuid'
      ])
    }
  }
</script>
<style lang="scss" scoped>
.contain-main {
  min-height: calc(100vh - 65px);
}
</style>